<template>
<div class="projects wrapper">
  <h1>Projects</h1>
  <div class="container">
    <router-link v-for="project in projects" :key="project.id" :to="`/project/${project.id}`" class="item">
      <div class="corner"></div>
      <h2>{{ project.title }}</h2>
      <div class="imgbox">
        <img :src="`/static/img/${project.image}`" :alt="project.image"/>
      </div>
      <p>{{ project.about }}</p>
    </router-link>
  </div>
</div>
</template>

<script>
export default {
  name: 'projects',
  data () {
    return {
      projects: [],
      columns: 3
    }
  },
  async mounted () {
    try {
      const resp = await fetch(`https://gigavoid.com/api/project`)
      this.projects = await resp.json()
    } catch (err) {
      console.log(err)
    }
  }
}
</script>

<style scoped>
a {
  color: #2c3e50;
  text-decoration: none;
}

img {
  max-width: 200px;
  max-height: 150px;
}

.projects {
  padding-left: 10px;
}

.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  height: auto;
  width: 900px;
  margin-left: -10px;
  padding-bottom: 10px;
}

.item {
  width: calc(860px / 3);
  margin-top: 10px;
  margin-left: 10px;
  border: 1px solid #a0b8b8;
  text-align: center;
  transition: .2s;
}

.item:hover {
  border-color: #2c3e50;
  background-color: #f7fdfb;
}

.item:hover .corner {
  border-left-color: #2c3e50;
  border-bottom-color: #f7fdfb;
}

.corner {
  width: 0px;
  height: 0px;
  border-bottom: 20px solid #FFF;
  border-left: 20px solid #a0b8b8;
  transition: .2s;
}

.item h2 {
  margin-top: 0px;
}

.imgbox {
  display: flex;
  align-items: center;
  width: 200px;
  height: 150px;
  margin: auto;
}

@media (max-width: 900px) {
  .container {
    width: 100%;
  }

  .item {
    width: calc(50% - 10px);
  }
}

@media (max-width: 600px) {
  .item {
    width: calc(100% - 10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projects.vue